module.exports = __webpack_public_path__ + "img/img_2.f0c36c5f.png";